const moment = require( 'moment' );
const IF = require( "infrontjs" );

import template from './IndexTemplate.html';
import '@khmyznikov/pwa-install';

import './../../components/general/main-menu';
import './../../components/general/header-bar';
import './../../components/routine/routine-check-item';

import { InAppState } from "../base/InAppState";
import { RoutinePlan } from "../../model/RoutinePlan";

export class IndexState extends InAppState
{
    static ROUTE = '/';
    static ID = 'index';

    async enter()
    {
        let activePlan = null;
        const resp = await this.app.api.get(  '/routine/active?filter-checkables' );
        if ( 200 === resp.status )
        {
            const activeRoutineData = await resp.json();
            activePlan = new RoutinePlan( activeRoutineData )
        }

        this.app.container.innerHTML = this.app.view.getHtml(
            template,
            {
                activePlan : activePlan
            }
        );

        this.app.container.querySelectorAll( 'routine-check-item' ).forEach( ci =>
        {
            ci.addEventListener( 'logActivity', async ( event ) => {

                const checkItem = event.currentTarget;
                const uuid = event.detail.uuid;

                checkItem.setLoadingState();

                const res = await this.app.api.post( '/routine/check/' + uuid );
                if ( 201 === res.status )
                {
                    checkItem.markChecked();
                }
                else
                {
                    this.app.gui.showSnackbarError( 'Fehler beim Speichern. Bitte versuchen Sie es später erneut.' );
                }
                checkItem.removeLoadingState();
            });

            ci.addEventListener( 'unlogActivity', async ( event ) => {
                const checkItem = event.currentTarget;
                const uuid = event.detail.uuid;

                this.app.gui.showGenericConfirmModal(
                    'Abhaken wieder rückgängig machen?',
                    async () => {

                        checkItem.setLoadingState();

                        const res = await this.app.api.delete( '/routine/check/' + uuid );
                        if ( 200 === res.status )
                        {
                            checkItem.unmarkChecked();
                        }
                        else
                        {
                            this.app.gui.showSnackbarError( 'Fehler beim Speichern. Bitte versuchen Sie es später erneut.' );
                        }
                        checkItem.removeLoadingState();
                    }
                )
            });
        });

        const pwaInstall = document.getElementsByTagName('pwa-install')[0];
        if ( false === pwaInstall.isUnderStandaloneMode )
        {
            pwaInstall.showDialog();
        }
    }

    async exit()
    {
        this.app.container.querySelectorAll( 'routine-check-item' ).forEach( item => item.removeEventListeners( 'logActivity' ) );
        this.app.container.querySelectorAll( 'routine-check-item' ).forEach( item => item.removeEventListeners( 'unlogActivity' ) );
    }
};
